import { useState } from 'react';

import { useDeviceType } from '@braskai/ui-kit';
import { useLocalStorage } from 'react-use';

// eslint-disable-next-line boundaries/element-types
import { SContainer, SDrawer } from '@/widgets/sidebar/ui/DesktopSidebar/styled';

import { MixpanelEvents } from '@/shared/thirdParty';

import { RecordingSidebarContent } from './RecordingSidebarContent';

type Props = {
  isAuthenticated?: boolean;
};

const LS_LOCKED_SIDEBAR = 'lockedSidebar';

export const RecordingSidebar = ({ isAuthenticated = true }: Props) => {
  const { isDesktop, isLaptop } = useDeviceType();
  const [isOpen, setIsOpen] = useState(false);
  const [lockedSidebar, setLockedSidebar] = useLocalStorage(LS_LOCKED_SIDEBAR, true);

  const onMouseEnter = () => {
    setIsOpen(true);
  };

  const onMouseLeave = () => {
    setIsOpen(false);
  };

  const handleLocked = () => {
    setLockedSidebar(!lockedSidebar);

    if (isOpen) {
      setIsOpen(false);
    }

    if (lockedSidebar) {
      MixpanelEvents.hideSideBarClick();
    } else {
      MixpanelEvents.lockSideBarClick();
    }
  };

  const handleCloseSidebar = () => {
    setIsOpen(false);
  };

  if (!isDesktop && !isLaptop) {
    return null;
  }

  return (
    <SContainer $locked={lockedSidebar}>
      <SDrawer
        $hover={isOpen}
        $locked={lockedSidebar}
        variant="permanent"
        open
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <RecordingSidebarContent
          isAuthenticated={isAuthenticated}
          isOpen={isOpen}
          locked={lockedSidebar}
          handleCloseSidebar={handleCloseSidebar}
          handleLocked={handleLocked}
        />
      </SDrawer>
    </SContainer>
  );
};
